module.exports = __webpack_public_path__ + "static/travelzik3-3861a1a1a241d63f3d34b51c19a61a42.png";